import { IPmListFilter } from '../interfaces/IPmListFilter';

export const initialPmListFilter: IPmListFilter = {
  name: 'Новый фильтр',
  years: [],
  ignoreKno: false,
  includeChildKno: false,
  includeDomainChild: false,
};
